import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useContent } from "../lib/ContentContext";

const Col = ({ title, links }) => (
  <div>
    <p className="eyebrow mb-5">{title}</p>
    <ul className="space-y-3">
      {links.map(([to, label]) => (
        <li key={to}>
          <Link to={to} className="text-sm text-slate-300 hover:text-[#f3d77a] transition-colors" data-testid={`footer-link-${to.replace(/\//g, "") || "home"}`}>
            {label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => {
  const { content } = useContent();
  const c = content.contact;
  return (
    <footer className="relative border-t border-[#d4af37]/15 bg-[#05060a] overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 pt-20 pb-10">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4 space-y-6">
            <Logo />
            <p className="text-sm text-slate-400 max-w-sm leading-relaxed">{content.company.summary}</p>
            <p className="eyebrow">{content.company.tagline}</p>
          </div>
          <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-4 gap-10">
            <Col title="Company" links={[["/about", "About Us"], ["/founder/zahir-patel", "Founder & CEO: Zahir Patel"], ["/vision", "Vision & Innovation"], ["/news", "News"]]} />
            <Col title="Platforms" links={[["/platforms", "Our Businesses"], ["/indril", "IND RIL"], ["/urgent-sell-buy", "Urgent Sell & Buy"], ["/boss-ai-os", "BOSS AI OS"]]} />
            <Col title="Legal" links={[["/legal", "Privacy Policy"], ["/legal?tab=terms", "Terms of Use"]]} />
            <div>
              <p className="eyebrow mb-5">Contact</p>
              <ul className="space-y-3 text-sm text-slate-300">
                {c.email ? <li><a href={`mailto:${c.email}`} className="hover:text-[#f3d77a]">{c.email}</a></li> : null}
                {c.phone ? <li>{c.phone}</li> : null}
                <li><Link to="/contact" className="hover:text-[#f3d77a] transition-colors" data-testid="footer-contact-link">Send an enquiry</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <p className="font-display font-extrabold text-[8.6vw] leading-[0.8] tracking-tight text-white/[0.04] mt-16 select-none whitespace-nowrap" aria-hidden="true">
          BOSS EMPIRE
        </p>
        <div className="mt-6 pt-6 border-t border-white/5 flex flex-col sm:flex-row gap-4 justify-between text-xs text-slate-400">
          <p>© {new Date().getFullYear()} {content.company.name}. All rights reserved.{c.cin ? ` CIN: ${c.cin}` : ""}</p>
          <Link to="/admin" rel="nofollow" className="hover:text-[#f3d77a] transition-colors" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
};
